import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GridPaginationModel } from '@thirdspacelearning/library';

import { getLearningObjectives, getYears } from '@api';
import { CurriculumQueryKeys } from '@services';
import { Country, SearchParams } from '@types';

const useLoSelection = (
    searchParams: SearchParams,
    paginationModel: GridPaginationModel,
    country?: Country,
) => {
    const {
        data: los,
        isLoading: losIsLoading,
        isFetching: losIsFetching,
        isError: losIsError,
    } = useQuery({
        queryKey: [CurriculumQueryKeys.LOS, paginationModel, searchParams],
        queryFn: () =>
            getLearningObjectives({
                ...searchParams,
                page: paginationModel.page + 1,
                per_page: paginationModel.pageSize,
                country: country || Country.GB,
            }),
        retry: 1,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        staleTime: Infinity,
    });

    const {
        data: years,
        isLoading: yearsIsLoading,
        isError: yearsIsError,
    } = useQuery({
        queryKey: [CurriculumQueryKeys.YEARS],
        queryFn: () => getYears(),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    const isInitialLoad = yearsIsLoading || losIsLoading;
    const isError = yearsIsError || losIsError;
    const isGridLoading = losIsFetching;

    return {
        los,
        years,
        isInitialLoad,
        isError,
        isGridLoading,
    };
};

export default useLoSelection;
